import * as React from 'react';
import { ExtensionSlot } from '../components/ExtensionSlot';
import { SwitchErrorInfo } from '../components/SwitchErrorInfo';
/**
 * The default error info component. Just uses the "error" extension slot.
 * Leverage the default one by registration of respective extensions using
 * the "error" name.
 */
export const DefaultErrorInfo = (props) => (React.createElement(ExtensionSlot, { name: "error", params: props, empty: () => React.createElement(SwitchErrorInfo, { ...props }) }));
DefaultErrorInfo.displayName = 'DefaultErrorInfo';
//# sourceMappingURL=DefaultErrorInfo.js.map